import {
  bootstrapFailure,
  bootstrapRequest,
  bootstrapSuccess,
} from 'store/reducers/main';
import { userSetCredentials } from 'store/reducers/user';

import { logOut } from './authentication';
import { fetchData } from './fetchData';

export const loadBootstrap = () => (dispatch, getState) =>
  fetchData({
    endpoint: 'bootstrap',
    actions: [bootstrapRequest, bootstrapSuccess, bootstrapFailure],
  })(dispatch, getState).then(({ success, data, status }) => {
    if (success && data.data.user.credentials.token) {
      const { token, uuid } = data.data.user.credentials;
      dispatch(userSetCredentials({ token, uuid }));
      localStorage.setItem('token', token);
      return { success, data };
    }
    if (status === 401) {
      logOut('/');
    }
    return { success: false };
  });

export const searchProviders = (keyword) => (dispatch, getState) =>
  fetchData({
    endpoint: `search/providers?q=${keyword}`,
    actions: [null, null, null],
  })(dispatch, getState);
